export default {
  cloudMessageApiBaseUrl: 'https://cloud-message-dev.quickytools.com',
  functionsBaseUrl: 'https://us-central1-quickytools-dev.cloudfunctions.net',
  communityBaseUrl: 'https://discourse-npe.quickytools.com'
}
